// Mock data for Computheer IT support website

export const siteInfo = {
  name: "COMPUTHEER",
  tagline: "COMPUTER SERVICE EN REPARATIES",
  phone: "06-12562049",
  phoneRaw: "+31612562049",
  email: "info@computheer.nl",
  address: {
    street: "Zeestraat 183",
    zip: "1943AB Beverwijk",
  },
  kvk: "77958330",
  btw: "NL002266922B76",
  hours: [
    { day: "Maandag", hours: "9:00 – 21:00" },
    { day: "Dinsdag", hours: "9:00 – 21:00" },
    { day: "Woensdag", hours: "9:00 – 21:00" },
    { day: "Donderdag", hours: "9:00 – 21:00" },
    { day: "Vrijdag", hours: "9:00 – 21:00" },
    { day: "Zaterdag", hours: "Op afspraak" },
    { day: "Zondag", hours: "Op afspraak" },
  ],
  socials: {
    facebook: "https://facebook.com",
    instagram: "https://instagram.com",
  },
};

export const googleReviewsUrl = "https://www.google.com/maps/place/Computheer/@52.4848699,4.6397175,17z/data=!4m8!3m7!1s0x47c5f0f60c9cb031:0xf8509b6742d4b558!8m2!3d52.4848667!4d4.6422924!9m1!1b1";

export const navItems = [
  { label: "Home", path: "/" },
  { label: "IT Support", path: "/it-support", highlight: true },
  { label: "Reparaties", path: "/diensten" },
  { label: "Zakelijk", path: "/zakelijk" },
  { label: "Hulp op afstand", path: "/hulp-op-afstand" },
];

export const heroFeatures = [
  {
    icon: "MapPin",
    title: "UW PROBLEEM OP LOCATIE OPGELOST",
    description:
      "Heeft u problemen met uw PC maar geen tijd om langs te komen? Dan komen wij naar u toe. Of het nu gaat om computer- of netwerkstoringen, wij lossen het snel en efficiënt op, direct bij u thuis of op kantoor.",
  },
  {
    icon: "Truck",
    title: "GRATIS OPHALEN EN BEZORGEN",
    description:
      "U kunt uw apparaten naar onze reparatiewerkplaats brengen, of laat deze kosteloos bij u ophalen. Wij zorgen voor een veilige afhandeling en terugbezorging.",
  },
  {
    icon: "Star",
    title: "BEKIJK ONZE RECENSIES",
    description:
      "Onze klanten waarderen ons met 4.9 sterren op Google. Lees wat ze over ons te zeggen hebben en ontdek waarom zij voor Computheer kiezen.",
  },
];

export const services = [
  {
    id: 1,
    icon: "Monitor",
    title: "Computer reparatie",
    description:
      "Snelle en vakkundige reparatie van alle merken computers en laptops. Van hardware defecten tot software problemen.",
    features: ["Scherm reparatie", "Toetsenbord vervanging", "Moederbord reparatie", "SSD/HDD upgrade"],
  },
  {
    id: 2,
    icon: "Wifi",
    title: "Netwerk & WiFi",
    description:
      "Problemen met internet of WiFi? Wij zorgen voor een stabiele verbinding in heel uw huis of kantoor.",
    features: ["WiFi installatie", "Netwerk troubleshooting", "Router configuratie", "Access points"],
  },
  {
    id: 3,
    icon: "ShieldCheck",
    title: "Virus verwijdering",
    description:
      "Last van virussen, malware of ongewenste pop-ups? Wij maken uw systeem weer schoon en veilig.",
    features: ["Malware scan", "Virus verwijdering", "Beveiligingsadvies", "Backup oplossingen"],
  },
  {
    id: 4,
    icon: "HardDrive",
    title: "Data herstel",
    description:
      "Gegevens kwijt? Wij herstellen bestanden van defecte harde schijven, SSD's en USB sticks.",
    features: ["Harde schijf herstel", "SSD recovery", "Foto/video redden", "Backup service"],
  },
  {
    id: 5,
    icon: "Laptop",
    title: "Laptop service",
    description:
      "Complete laptop service: van accu vervanging tot volledige reiniging en optimalisatie.",
    features: ["Accu vervanging", "Reiniging & koeling", "Scharnier reparatie", "Scherm vervanging"],
  },
  {
    id: 6,
    icon: "Headphones",
    title: "Hulp op afstand",
    description:
      "Direct geholpen via veilige externe verbinding. Snel opgelost zonder dat u de deur uit hoeft.",
    features: ["TeamViewer support", "Software installatie", "Instellingen hulp", "Advies op maat"],
  },
];

export const whyChooseUs = [
  {
    icon: "Clock",
    title: "Snelle service",
    description: "Binnen 24 uur geholpen, vaak nog dezelfde dag.",
  },
  {
    icon: "Euro",
    title: "Eerlijke prijzen",
    description: "Vooraf duidelijke prijsopgave, geen verrassingen achteraf.",
  },
  {
    icon: "Award",
    title: "15+ jaar ervaring",
    description: "Vakkundig, gecertificeerd en altijd up-to-date.",
  },
  {
    icon: "Users",
    title: "Persoonlijk contact",
    description: "Wij luisteren en denken met u mee.",
  },
];

export const reviews = [
  {
    name: "Familie De Bruin",
    rating: 5,
    date: "2 weken geleden",
    badge: "IT Support klant",
    text: "Sinds we het IT Support-abonnement hebben afgesloten hoeven we nergens meer naar om te kijken. Alles wordt bijgehouden, virussen zijn er niet meer en bij de kleinste vraag staat Computheer meteen klaar. Een enorme geruststelling.",
  },
  {
    name: "Linda van der Berg",
    rating: 5,
    date: "3 weken geleden",
    text: "Zeer vriendelijke en vakkundige hulp. Mijn laptop was binnen een dag weer helemaal in orde. Eerlijke prijs en goede communicatie. Aanrader!",
  },
  {
    name: "Peter Jansen",
    rating: 5,
    date: "1 maand geleden",
    text: "Computheer heeft mijn PC gered na een virus. Snelle service, duidelijke uitleg en een hele redelijke prijs. Top service!",
  },
  {
    name: "Marieke de Vries",
    rating: 5,
    date: "2 maanden geleden",
    text: "Kwam aan huis voor een netwerkprobleem. Binnen een uur was alles opgelost en werkt het WiFi nu door het hele huis perfect.",
  },
  {
    name: "Kees Bakker",
    rating: 5,
    date: "2 maanden geleden",
    text: "Goede hulp gehad met het herstellen van mijn foto's van een kapotte harde schijf. Alles terug! Heel blij mee.",
  },
  {
    name: "Sophie Dekker",
    rating: 5,
    date: "3 maanden geleden",
    text: "Heel professioneel en betrouwbaar. Heeft rustig alles uitgelegd en ook nog tips gegeven om problemen te voorkomen.",
  },
  {
    name: "Rob Visser",
    rating: 4,
    date: "4 maanden geleden",
    text: "Snelle en correcte afhandeling van laptop reparatie. Goede prijs-kwaliteit verhouding.",
  },
];

export const stats = [
  { value: "1500+", label: "Tevreden klanten" },
  { value: "125+", label: "Klanten met IT Support" },
  { value: "4.9", label: "Google reviews" },
  { value: "15+", label: "Jaar ervaring" },
];

// IT Support subscription plans (2 varianten — particulier + zakelijk)
export const itSupportPlans = [
  {
    id: "particulier",
    name: "IT Support Particulier",
    tagline: "Voor particulieren & gezinnen",
    priceMonthly: 15,
    priceYearly: 150,
    yearlyNote: "2 maanden gratis bij jaarbetaling",
    deviceLimit: "Voor 1 apparaat — extra apparaten? Vraag naar ons combitarief.",
    features: [
      "Professionele Bitdefender",
      "2 onderhoudsbeurten per jaar",
      "Onbeperkte hulp op afstand",
      "Vast aanspreekpunt",
      "Snelle hulp bij problemen",
    ],
    highlight: false,
    business: false,
    cta: "Bekijk abonnement",
  },
  {
    id: "zakelijk",
    name: "IT Support Zakelijk",
    tagline: "Voor MKB & ZZP",
    priceMonthly: 25,
    priceYearly: 250,
    yearlyNote: "Alle bedragen excl. BTW",
    deviceLimit: "Voor 1 apparaat — extra apparaten? Vraag naar ons combitarief.",
    features: [
      "Professionele Bitdefender voor al uw bedrijfsapparatuur",
      "2 onderhoudsbeurten per jaar",
      "Onbeperkte hulp op afstand",
      "Vast aanspreekpunt, geen callcenter",
      "Voorrang op reguliere klanten",
      "Periodieke facturatie mogelijk",
    ],
    highlight: true,
    business: true,
    cta: "Bekijk zakelijk abonnement",
  },
];

export const itSupportBenefits = [
  { icon: "ShieldCheck", title: "Professionele Bitdefender", description: "De beste beveiliging tegen virussen, ransomware en phishing — automatisch actueel." },
  { icon: "Wrench",      title: "2 onderhoudsbeurten per jaar", description: "Wij houden uw systemen fris, snel en up-to-date. Geen trage computers meer." },
  { icon: "Headphones",  title: "Onbeperkte hulp op afstand", description: "Vastgelopen? Bel ons — binnen enkele minuten kijken wij mee via een veilige verbinding." },
  { icon: "UserCheck",   title: "Vast aanspreekpunt", description: "U krijgt altijd dezelfde persoon aan de lijn. Geen callcenter, geen doorverwijzingen." },
  { icon: "Zap",         title: "Snelle hulp bij problemen", description: "Voorrang op reguliere klanten. Meestal binnen 24 uur geholpen." },
];

export const tariefs = {
  particulier: {
    hourly: "€ 65,-",
    label: "per uur — incl. BTW",
    note: "Geen voorrijkosten in regio IJmond",
  },
  zakelijk: {
    hourly: "€ 75,-",
    label: "per uur — excl. BTW",
    note: "Voor MKB, ZZP en organisaties",
  },
  remoteParticulier: {
    hourly: "€ 60,-",
    per15: "€ 15,-",
    label: "per uur incl. BTW — of € 15 per 15 minuten",
    note: "Afgerekend per 15 minuten",
  },
  remoteZakelijk: {
    hourly: "€ 70,-",
    per15: "€ 17,50",
    label: "per uur excl. BTW — of € 17,50 per 15 minuten",
    note: "Afgerekend per 15 minuten",
  },
};

export const serviceArea = [
  "Beverwijk",
  "Heemskerk",
  "Velsen",
  "IJmuiden",
  "Santpoort",
  "Wijk aan Zee",
  "Uitgeest",
  "Castricum",
];

export const images = {
  hero: "https://images.unsplash.com/photo-1483058712412-4245e9b90334?auto=format&fit=crop&w=1200&q=80",
  workstation: "https://images.unsplash.com/photo-1572361050255-002ce82a888c",
  laptopRepair: "https://images.unsplash.com/photo-1620368523635-df9d83338fc1",
  professional: "https://images.unsplash.com/photo-1646756089735-487709743361",
  circuitBoard: "https://images.pexels.com/photos/36861987/pexels-photo-36861987.jpeg",
  motherboard: "https://images.pexels.com/photos/9242258/pexels-photo-9242258.jpeg",
};
